export enum CopilotEntrypointType {
	BUBBLE = 'BUBBLE',
	SEARCH_PAGE_VARIATION_A = 'SEARCH_PAGE_VARIATION_A',
	SEARCH_PAGE_VARIATION_B = 'SEARCH_PAGE_VARIATION_B',
	BANNER_VARIATION_A = 'BANNER_VARIATION_A',
	BANNER_VARIATION_B = 'BANNER_VARIATION_B',
}
